export default __webpack_public_path__ + "static/media/Qe_11.6d1bd8f9.JPG";